<style lang="stylus" scoped>
    .slider-dilatancy
        position absolute
        bottom 32px
        left 12px

        .dilatancy-img
            position relative
            margin-bottom 16px
            cursor pointer
            user-select none
            img
                display block
                width 100%
                object-fit contain

            .dilatancy-imgtext
                display flex
                flex-wrap wrap
                align-content space-between
                position absolute
                left 0
                top 0
                width 100%
                height 100%
                padding 12px
                color #fff
                font-size 12px

                span
                    display block

            .dilatancy-img
                position relative
                margin-bottom 16px
                cursor pointer
                user-select none
                img
                    display block
                    width 100%
                    object-fit contain

                .dilatancy-imgtext
                    display flex
                    flex-wrap wrap
                    align-content space-between
                    position absolute
                    left 0
                    top 0
                    width 100%
                    height 100%
                    padding 12px
                    color #fff
                    font-size 12px

                    span
                        display block

                    .dilatancy-imgtext-space
                        font-weight 700
                        margin-bottom 12px
                        font-size 14px
                        text-shadow 0px 3px 20px rgba(224, 151, 0, 0.8)

                    .dilatancy-imgtext-buy
                        font-weight 400
                        font-size 12px

                    &.dilatancy-imgtext-en
                        .dilatancy-imgtext-space
                            line-height 12px
                            font-size 12px
                            margin-bottom 0

                    &.dilatancy-imgtext-langfit
                        padding 4px 8px


            .dilatancy-title
                display flex
                justify-content flex-start
                .dilatancy-text
                    display flex
                    font-size 12px
                    line-height 16px
                    span
                        font-size 12px
                        color rgba(34, 34, 34, 0.6)
                        line-height 14px
                    .dilatancy-used
                        color #017fff
                        font-weight 700

            .dilatancy-bar
                margin-top 8px
                height 6px
                background rgba(0, 0, 0, 0.06)
                border-radius 4px
                overflow hidden
                .process-inner
                    height 6px
                    border-radius 4px

        .dark-theme__dilatancy
            .dilatancy-title
                .dilatancy-text
                    span
                        color #fff
            .dilatancy-bar
                background rgba(255, 255, 255, .1)
        @media screen and (max-height: 550px)
            .slider-dilatancy
                display none
</style>

<template>
    <div class="slider-dilatancy" :class="{ 'dark-theme__dilatancy': isPCDarkMode == 2 }" :style="{ width: `${dilatancyWidth}px` }">
        <div
            class="dilatancy-img"
            @click="tobuy"
            v-if="!vip && showDilatancy && (internal || !['de', 'en', 'kr', 'es'].includes(lang) || isPC || !isBlackFriday || fuser)"
        >
            <img :src="require(`@/home/assets/img/dilatancy-${isPC ? 'pc' : 'online'}.png`)" draggable="false" alt="" />
            <p
                class="dilatancy-imgtext"
                :class="{
                    'dilatancy-imgtext-en': !internal || lang != 'zh',
                    'dilatancy-imgtext-langfit': langFit,
                }"
            >
                <span class="dilatancy-imgtext-space">{{ $t("moreSpace") }}</span>
                <span class="dilatancy-imgtext-buy">{{ $t("toVip") }}</span>
            </p>
        </div>
        <div class="dilatancy-img" v-if="showBlackFriday" @click="toBlackFriday">
            <img :src="require(`@/home/assets/img/christmas_${lang}_bottom.png`)" draggable="false" alt="" />
        </div>
        <div class="dilatancy-title" v-if="showDilatancy">
            <div class="dilatancy-text">
                <span class="dilatancy-used" :style="{ color: textColor }">{{ usedDilatancy }}</span>
                <span style="margin: 0 4px">/</span>
                <span class="dilatancy-total">{{ maxDilatancy }}</span>
            </div>
        </div>
        <div class="dilatancy-bar" :style="{ width: `${dilatancyWidth}px` }" v-if="showDilatancy">
            <div class="process-inner" :style="{ width: `${dilatancyWidth * barRatio}px`, 'background-color': barColor }"></div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Watch } from "vue-property-decorator";

    @Component
    export default class Dilatancy extends Vue {
        used_storage = null;
        max_storage = NaN;
        isBlackFriday = false;
        get userInfo() {
            return this.$store.state.userInfo;
        }
        get showDilatancy() {
            return !this.isTeamsApp && this.userInfo && this.userInfo.islogin && this.used_storage !== null;
        }
        get usedDilatancy() {
            return ((this.used_storage || 0) / 1024 / 1024).toFixed(2) + "M";
        }
        get maxDilatancy() {
            return ((this.max_storage || 0) / 1024 / 1024).toFixed(2) + "M";
        }
        get barRatio() {
            return this.used_storage / this.max_storage;
        }
        get barWidth() {
            return;
        }
        get barColor() {
            return this.barRatio >= 0.8 ? "#FD6969" : "#017FFF";
        }
        get textColor() {
            return this.barRatio >= 0.8 ? "#FD6969" : this.isPCDarkMode == 2 ? "#ffffff" : "#017fff";
        }
        get dilatancyWidth() {
            return this.isPC ? 156 : 136;
        }
        get langFit() {
            return !this.internal && ["fr", "it"].includes(this.lang);
        }

        getStorage() {
            if (!this.userInfo || !this.userInfo.islogin) return;
            this.$edApi
                .getUserInfo({
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                })
                .then((res) => {
                    this.used_storage = res?.data?.used_storage;
                    this.max_storage = res?.data?.max_storage;
                });
        }
        get showBlackFriday() {
            return !this.internal && ["de", "en", "kr", "es"].includes(this.lang) && !this.isPC && this.isBlackFriday && !this.fuser;
        }
        get vipStatus() {
            let role = "";
            if (this.vip) {
                role = this.fuser ? "lifetime" : "nonlifetime";
            } else {
                role = "nonvip";
            }
            return role;
        }
        get blackFridayPopup() {
            return this.showBlackFriday && this.vipStatus;
        }
        @Watch("blackFridayPopup")
        watchBlackFridayPopup() {
            if (this.blackFridayPopup) {
                this.sensors.track("leftnavbar_popup", {
                    popup_type: this.vipStatus + "_popup",
                });
            }
        }
        toBlackFriday() {
            this.sensors.track("leftnavbar__button", {
                button_type: this.vipStatus + "_pay",
            });
            let params = "";
            if (this.userInfo && this.userInfo.user_id) {
                params += `&custom=${encodeURIComponent(btoa(JSON.stringify({ id: this.userInfo.user_id, token: this.userInfo.token })))}`;
            }
            if (this.userInfo && this.userInfo.ws_id) {
                params += `&uid=${this.userInfo.ws_id}`;
            }
            let url =
                "https://www.edrawsoft.com/shop/edraw-sales-promotion.html?utm_source=link_in_product_online&utm_medium=productmax&utm_campaign=edraw-holiday-en2023&utm_term=136*72&utm_content=button_21113677_2023-12-12";
            if (this.lang === "de") {
                url =
                    "https://www.edrawsoft.com/de/sales-promotion.html?utm_source=link_in_product&utm_medium=product&utm_campaign=de-ny23-yt&utm_content=link_21111047_2023-12-12";
            }
            if (this.lang === "kr") {
                url =
                    "https://www.edrawsoft.com/kr/store.html?utm_source=link_in_product&utm_medium=product&utm_campaign=christmas-event&utm_content=link_21113201_2023-12-13";
            }
            if (this.lang === "es") {
                url =
                    "https://www.edrawsoft.com/es/sales-promotion.html?utm_source=link_in_product&utm_medium=popups_max&utm_campaign=popups-max-Christmas-2023&utm_content=link_21112315_2023-12-12";
            }
            window.open(`${url}${params}`);
        }
        tobuy() {
            this.$openBuyPage("cloudSpaceLeftBottom");
        }
        @Watch("lang")
        WatchLangChange() {
            if (this.lang === "en") {
                this.isBlackFriday = new Date().getTime() < new Date("2024-01-05 23:59:59").getTime();
            } else if (this.lang === "de") {
                this.isBlackFriday = new Date().getTime() < new Date("2023-12-26 23:59:59").getTime();
            } else {
                this.isBlackFriday = new Date().getTime() < new Date("2023-12-25 23:59:59").getTime();
            }
        }
        created() {}
        mounted() {
            this.$bus.$on("refreshEv", () => {
                this.getStorage();
            });
            this.$bus.$on("getStorage", () => {
                this.getStorage();
            });
            // this.$bus.$on("loginSucc",()=>{
            //     this.getStorage();
            // })
            this.getStorage();
            if (this.lang === "en") {
                this.isBlackFriday = new Date().getTime() < new Date("2024-01-05 23:59:59").getTime();
            } else if (this.lang === "de") {
                this.isBlackFriday = new Date().getTime() < new Date("2023-12-26 23:59:59").getTime();
            } else {
                this.isBlackFriday = new Date().getTime() < new Date("2023-12-25 23:59:59").getTime();
            }
        }

        beforeDestroy() {
            this.$bus.$off("refreshEv");
            this.$bus.$off("getStorage");
        }
    }
</script>
<i18n>
{
    "zh": {
        "moreSpace": "需要更多云空间？",
        "toVip": "点此开通VIP"
    },
    "en": {
        "moreSpace": "Need more Cloud Storage?",
        "toVip": "Buy Now"
    },
    "fr": {
        "moreSpace": "Vous avez besoin de plus de stockage dans le cloud ?",
        "toVip": "Acheter Maintenant"
    },
    "de": {
        "moreSpace": "Benötigen Sie mehr Cloud-Speicher?",
        "toVip": "Jetzt upgraden"
    },
    "jp": {
        "moreSpace": "クラウドストレージがさらに必要ですか？",
        "toVip": "アップグレード"
    },
    "es": {
        "moreSpace": "¿Necesita más almacenamiento en la nube?",
        "toVip": "Actualizar Ahora"
    },
    "pt": {
        "moreSpace": "Precisa de mais armazenamento na nuvem?",
        "toVip": "Atualize Agora"
    },
    "it": {
        "moreSpace": "Hai bisogno di più spazio di archiviazione su cloud?",
        "toVip": "Aggiorna Ora"
    },
    "tw": {
        "moreSpace": "需要更多雲端儲存空間嗎？",
        "toVip": "升級至 Premium"
    },
    "kr": {
        "moreSpace": "더 많은 클라우드 스토리지가 필요하십니까?",
        "toVip": "지금 업그레이드하기"
    },
    "id": {
        "moreSpace": "Butuh Penyimpanan Cloud lebih besar?",
        "toVip": "Tingkatkan Sekarang"
    }
}
</i18n>
